<template>
  <div>
    <div v-if="!!value" class="table_label" :class="{ primary: primary }">
      <span :style="labelStyle">{{ text }}</span>
      <span :style="valueStyle">{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: '' },
    value: { type: [Number, String], default: '' },
    labelKey: { type: String, default: '' },
    primary: { type: Boolean, default: false },
    labelStyle: { type: [Object, String], default: '' },
    valueStyle: { type: [Object, String], default: '' },
  },
  computed: {
    text() {
      if (!this.labelKey) return this.label || ''
      return this.$l(this.labelKey) || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.table_label {
  span:empty {
    display: none;
  }
  span:first-child {
    color: #303133;
    &::after {
      content: '：';
    }
  }
}

.table_label.primary {
  span:last-child {
    color: #409eff;
  }
}
</style>
